import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "opModal selectQrCodesModal" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center my-3" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "op-cell justify-content-center"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_10 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_11 = { class: "op-cell op-cell--wrap" }
const _hoisted_12 = { class: "fw-semibold text-truncate w-100" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "op-cell" }
const _hoisted_15 = { class: "op-cell" }
const _hoisted_16 = {
  key: 2,
  class: "mobileList"
}
const _hoisted_17 = {
  key: 0,
  class: "listItem"
}
const _hoisted_18 = {
  key: 0,
  class: "op-cell justify-content-center"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "listItemCell main" }
const _hoisted_21 = { class: "fs-12" }
const _hoisted_22 = { class: "listItemCell small" }
const _hoisted_23 = { class: "d-flex mt-4" }
const _hoisted_24 = { class: "form-group w-50 me-2" }
const _hoisted_25 = { class: "form-group w-50 ms-2" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr_config_filters = _resolveComponent("qr-config-filters")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_icon_check_mark = _resolveComponent("icon-check-mark")!
  const _component_op_th = _resolveComponent("op-th")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "pageTitle mb-0" }, "Seleziona QR Code", -1)),
        (_ctx.$store.state.commesse.selectedCommessa)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Commessa selezionata: " + _toDisplayString(_ctx.$store.state.commesse.selectedCommessa.name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.$store.state.isMobile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge fs-6", _ctx.selectedRows.length > 0 ? 'bg-primary' : 'bg-secondary'])
              }, _toDisplayString(_ctx.selectedRows.length) + " selezionati ", 3)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
    _createVNode(_component_accordion, {
      label: "Filtri",
      class: "my-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_qr_config_filters, {
          modelValue: _ctx.filterVm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterVm) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (!_ctx.$store.state.isMobile)
      ? (_openBlock(), _createBlock(_component_op_table, {
          key: 1,
          items: _ctx.items,
          name: "qrConfigs",
          filterVm: _ctx.filterVm,
          total: _ctx.total
        }, {
          header: _withCtx(() => [
            (_ctx.$store.state.isCommessaEditor())
              ? (_openBlock(), _createBlock(_component_op_th, {
                  key: 0,
                  class: "justify-content-center",
                  width: 100,
                  resizable: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll(_ctx.items)))
                    }, [
                      _cache[10] || (_cache[10] = _createTextVNode(" Tutti ")),
                      _createVNode(_component_icon_check_mark)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_op_th, {
              width: "10%",
              sort: "createdOn"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Data creazione")
              ])),
              _: 1
            }),
            _createVNode(_component_op_th, {
              width: "25%",
              sort: "name"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Nome")
              ])),
              _: 1
            }),
            _createVNode(_component_op_th, {
              width: "15%",
              sort: "info"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("Info")
              ])),
              _: 1
            }),
            _createVNode(_component_op_th, {
              width: "25%",
              sort: "isActive"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Attivo")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(({ items }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((items as OM.QrConfig[]), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "op-row",
                style: {"position":"relative"},
                key: item.identifier
              }, [
                (_ctx.$store.state.isCommessaEditor())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRows) = $event)),
                        value: item
                      }, null, 8, _hoisted_8), [
                        [_vModelCheckbox, _ctx.selectedRows]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["op-cell", { 'op-cell--wrap': _ctx.$store.state.isCommessaEditor() }])
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
                  (_ctx.$store.state.isCommessaEditor())
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, [
                        _cache[15] || (_cache[15] = _createTextVNode("Creato da: ")),
                        _createElementVNode("b", null, _toDisplayString(item.createdBy && item.createdBy.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.isCommessaEditor())
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, [
                        _cache[16] || (_cache[16] = _createTextVNode("Modificato da: ")),
                        _createElementVNode("b", null, _toDisplayString(item.modifiedBy && item.modifiedBy.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1),
                  _createElementVNode("small", {
                    class: "text-muted text-truncate w-100",
                    title: item.description
                  }, _toDisplayString(item.description), 9, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.info), 1),
                _createElementVNode("div", _hoisted_15, [
                  (item.isActive)
                    ? (_openBlock(), _createBlock(_component_icon_check_mark, {
                        key: 0,
                        class: "text-success"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          empty: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("Nessuna riga da mostrare")
          ])),
          _: 1
        }, 8, ["items", "filterVm", "total"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_ctx.items.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[18] || (_cache[18] = [
                _createElementVNode("div", { class: "listItemCell main" }, "Nessuna riga da mostrare", -1)
              ])))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listItem",
              style: {"position":"relative"},
              key: i
            }, [
              (_ctx.$store.state.isCommessaEditor())
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRows) = $event)),
                      value: item
                    }, null, 8, _hoisted_19), [
                      [_vModelCheckbox, _ctx.selectedRows]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(item.description), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                (item.isActive)
                  ? (_openBlock(), _createBlock(_component_icon_check_mark, {
                      key: 0,
                      class: "text-success"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _cache[19] || (_cache[19] = _createElementVNode("label", null, "Quantità per ogni QR selezionato", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quantity) = $event))
        }, null, 512), [
          [_vModelText, _ctx.quantity]
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[21] || (_cache[21] = _createElementVNode("label", null, "Materiale per ogni QR selezionato", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.material) = $event))
        }, [
          _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "— Seleziona materiale —", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (m) => {
            return (_openBlock(), _createElementBlock("option", {
              key: m.identifier,
              value: m
            }, _toDisplayString(m.name), 9, _hoisted_26))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.material]
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args)))
      }, " Conferma selezione "),
      _createElementVNode("button", {
        class: "btn btn-danger-outline ms-2",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
      }, " Annulla ")
    ])
  ]))
}